import { NgZone, Component,ElementRef, ViewChild, EventEmitter, OnChanges, Input, OnInit, Output,SimpleChanges} from '@angular/core';
import {ReportService} from '../inservice/report.service';
import { CookieService } from '../_services/cookie.service';
import { Router} from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css']
})
export class LogoComponent implements OnInit, OnChanges {
	fileName:string;
	@Input() userInfo: any;
	@Input() logoInfo: any;
	@Input() q: string;
	@Input() r: string;
	logos=[];
	acceptType=[];
	fileReader: FileReader;
	password:string;
	toReset=false;
	@ViewChild('file', {static: true}) file: ElementRef;
	@Output() logOut = new EventEmitter();
	constructor(private fb: FormBuilder, private cookieService: CookieService, private router: Router,public reportService: ReportService, private modalService: NgbModal, private ngZone : NgZone) { 
		
		this.acceptType=this.reportService.acceptFileType.split(',');
	}

	ngOnInit(): void {
		if(this.logoInfo){
			if(this.logoInfo.LOGOS&&this.logoInfo.LOGOS.length>0){
				this.logos=this.logoInfo.LOGOS;
			}else{
				this.logos=[];
			}
		

		}
    this.getUserInfo();
	}
  incorrect=false;
  verifyEris(){
    let inputJson={"PROCEDURE":"verifyeriscustomer","USER_ID":parseInt(this.userInfo.USER_ID),"USERNAME":this.ERIS_USERNAME,"PASSWORD":this.ERIS_PASSWORD};

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			
      if(data.RESPONSE_STATUS=='Y'){

        this.userInfo.ERIS_CUSTOMER_ID=data.ERIS_CUSTOMER_ID

        let inputJson2 = {
          "PROCEDURE": "updaterwuser", "USER_ID": parseInt(this.userInfo.USER_ID), "UPDATE_USER_ID":parseInt(this.userInfo.USER_ID), "ERIS_CUSTOMER_ID":data.ERIS_CUSTOMER_ID
        }
        this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return										
			}
          $('#ERIS').modal('hide');
          })
      }else{
        this.incorrect=true;
		this.throwError(data);
      }
    })
  }
  ERIS_USERNAME;
  ERIS_PASSWORD;
  getUserInfo(){
    
    let inputJson={"PROCEDURE":"getrwuser","USER_ID":parseInt(this.userInfo.USER_ID),"REQUESTED_USER_ID":parseInt(this.userInfo.USER_ID)}
    
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);
			  }else{		
      this.userInfo=data;
			  }
    })

  }
	//ngOnDestroy(): void {
	//	document.removeEventListener('click', this.handleClickBoundary.bind(this), false);
	//}
  open(content) {
    this.modalService.open(content, { centered: true }).result.then((result) => {
    
    });
    
  }
	ngOnChanges(changes: SimpleChanges): void {
		if ('logoInfo' in changes) {
			if(changes.logoInfo.currentValue){
				this.logos=changes.logoInfo.currentValue.LOGOS;
			}    
			
		}
	}
	onDeleteLogo(logo: any) {
		Swal.fire({
			//position: 'center',
			
			title: 'Are you sure?',
			icon: 'warning',
			html: "You won't be able to revert this!",
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'No, cancel!',
			showCancelButton: true,
			focusCancel: true,
			allowOutsideClick: false,
		}).then((result) => {
			if (result.value) {
				//this.reportService.loading = true;
				/*let inputJson={"PROCEDURE":"deletecompanylogo","CUSTOMER_ID":this.logoInfo.CUSTOMER_ID,"LOGO_ID": logo.LOGO_ID};
				this.reportService.logouniveralService(inputJson).subscribe( (data) => { 
					Swal.mixin({
						toast: true,
						position: 'center',
						showConfirmButton: false,
						timer: 2000
					}).fire({
						icon: 'success',
						title: `The logo has been deleted`
					});
					this.getLogo();
				});*/
			}
		});
	}
  addLogo(){
    if (!this.fileReader) {
      this.fileReader = new FileReader();
      this.listenFileReader();
    }
    const file = this.file.nativeElement.files[0]; 

    //this.file.nativeElement.value = null;
    if(file){
    const ext = file.name.replace(/.+\./, '');
    if (['png', 'jpg', 'jpeg', 'gif','PNG','JPG','JPGE','GIF'].indexOf(ext) === -1) {
     // Swal.fire('Oops...', 'Only support .png|.jpg|.jpeg|.gif', 'error');
      return;
    }
    $("#uploadBtn").addClass("disabled");
    this.fileReader.readAsDataURL(file);
    this.fileName=file.name;
   // let inputJson={"PROCEDURE": "insertcompanylogo","CUSTOMER_ID": this.logoInfo.CUSTOMER_ID,"TITLE": "","FILENAME": "","URL": "",	"THUMBNAIL": "",	"LOGO_LOCATION":"" };
  }
   
  }
  curRptPara = {
		'RESUME': { "FILE_URL": "" },
		'SIGNATURE': {},
		'name': 'Choose File',
	};
  curRptPara2 = {
		'RESUME': { "FILE_URL": "" },
		'SIGNATURE': {},
		'name': 'Choose File',
	};
  @ViewChild('signature') signature: ElementRef
  public uploadFile3(callback) {
		let that = this;
		// $('#inputWarn').css('display', 'none');
		$('#inputSuccess2').css('display', 'none');
		const file = this.signature.nativeElement.files[0]; 
		if (!file) {
			$('#inputWarn').css('display', 'inline-block');
			return
		}
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
		$('#spinner2').css('display', 'inline-block');
		/*const ext = file.name.replace(/.+\./, '');
		if (['png','PNG', 'jpg','JPG', 'jpeg','JPEG', 'gif','GIF'].indexOf(ext) === -1) {
			Swal.fire('Oops...', 'Only support .png|.jpg|.jpeg|.gif', 'error');
			return;
		}*/
		//this.fileReader.readAsDataURL(file);
		let reader = new FileReader();
		reader.onloadend = function (e) {
			let data = e.target.result.toString().split(',')[1];
			//let inputJson={"filename":file.name,"customerid":that.userId,"Order":'123',"reportID":'123','r':'123',"fdata":data}; 
			let inputJson = { "filename": file.name, "fdata": data, "user_id":parseInt(that.userInfo.USER_ID), 'file_type':"USER_SIGNATURE" }
			that.reportService.uploadFile2(inputJson).subscribe(result => {
				if (result.RESPONSE_STATUS=='N') {
					that.throwError(result);
					return										
				}
				that.curRptPara2.RESUME = result; 
				that.signature.nativeElement.value = null;
				$('#spinner2').css('display', 'none');
				$('#inputSuccess2').css('display', 'inline-block');
				that.curRptPara2.name = 'Choose File';
				callback();
			})
			//.error
		}
		reader.readAsDataURL(file);

	}
	changeSignature(file, user) {
		if (file != null) {
			this.uploadFile3(() => {
				user.SIGNATURE_URL = this.curRptPara2.RESUME.FILE_URL;
				let inputJson = { "PROCEDURE": "updaterwuser", "USER_ID": this.userInfo.USER_ID, "UPDATE_USER_ID": user.USER_ID, "SIGNATURE_URL": this.curRptPara2.RESUME.FILE_URL }
				
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					if(data.RESPONSE_STATUS=='N'){
						this.throwError(data);
					  }	
				});


			});
		} else {
			let inputJson = { "PROCEDURE": "updaterwuser", "UPDATE_USER_ID": user.USER_ID, "USER_ID": this.userInfo.USER_ID, "SIGNATURE_URL": "" }
			user.SIGNATURE_URL = "";
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				if(data.RESPONSE_STATUS=='N'){
					this.throwError(data);
				  }
			});

		}
		this.curRptPara2 = {
			'RESUME': { "FILE_URL": "" },
			'SIGNATURE': {},
			'name': 'Choose File',
		};
	}
  selectFile2() {
		this.signature.nativeElement.click();
	}
  getName2() {
		this.curRptPara2.name = this.signature.nativeElement.files[0].name;
	}
  transfer(e) {
    
    let fileData=e.target.result.split(',')[1];
    //let inputJson={"UploadFileName":this.fileName,"customerid":this.logoInfo.CUSTOMER_ID,"logoData":fileData}
   // this.reportService.saveLogoService(inputJson).subscribe( (data) => {
    let inputJson={"filename":this.fileName,"user_id":this.userInfo.USER_ID.toString(),"company_id":this.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"LOGO","filetitle":"","fdata":fileData};
	
	this.reportService.uploadFile2(inputJson).subscribe(result=>{
	$("#uploadBtn").removeClass("disabled");
       /* Swal.mixin({
         toast: true,
         position: 'center',
         showConfirmButton: false,
         timer: 2000
       }).fire({
         type: 'success',
         title: `The logo has been added`
       });*/
	   if (result.RESPONSE_STATUS=='N') {
		this.throwError(result);
		return										
	}
       this.file.nativeElement.value=null;
       this.fileName=null;
       this.getLogo();
       
     });
  }

  listenFileReader() {
    this.fileReader.onload = (e) => {
      this.transfer(e);
    };
  }
  chooseLogo(logoId){
    for(let logo of this.logoInfo.LOGOS){
      if(logo.LOGO_ID==logoId){
        this.reportService.defaultLogo=logo
      }
    }
     
  }

 private getLogo(){
   	let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":this.userInfo.USER_ID,"FILE_TYPE":"LOGO"};
    this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		if(data.RESPONSE_STATUS=='N'){
			this.throwError(data);
		  }else{	
		this.logoInfo=data;
		this.logos=this.logoInfo. RW_UPLOAD_FILES;
		  }

    })
  }
  logout(){
    this.logOut.emit();
    
  }
  @ViewChild('resume') resume: ElementRef;

  addResume(f, user) {
		//if(f != null){
		const file = $("#resume").prop("files")[0]; 
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
		let that = this;
		let reader = new FileReader();
		reader.onloadend = function (e) {
			if(that.curRptPara.name=='Choose File'){
				return
			}
			let data = e.target.result.toString().split(',')[1];
			let inputJson = { "filename": file.name, "fdata": data, "user_id":that.userInfo.USER_ID, "file_type":"USER_RESUME"};
			that.reportService.uploadFile2(inputJson).subscribe(result => {
				if (result.RESPONSE_STATUS=='N') {
					that.throwError(result);
					return										
				}
				that.curRptPara.RESUME = result; 
        		$("#resume").value = null;
				let inputJson2 = { "PROCEDURE": "insertuserresume", "USER_ID": that.userInfo.USER_ID, "RESUME_FILENAME": that.curRptPara.name, "RESUME_TITLE": that.curRptPara.name, "RESUME_URL": that.curRptPara.RESUME.FILE_URL }
				that.curRptPara = {
					'RESUME': { "FILE_URL": "" },
					'SIGNATURE': {},
					'name': 'Choose File',
				};
				inputJson2["RESUME_USER_ID"] = user.USER_ID;
				that.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data2 => {
					if(data2.RESPONSE_STATUS=='N'){
						that.throwError(data);
					  }else{	
					that.ngZone.run(() => {
						user.RESUMES.push(data2);
					});
				}
				});
				})
			}
		reader.readAsDataURL(file);

		//}else{
		//	return;
		//}
		}
    selectFile() {
      $("#resume").click();
    }
    getName() {
      this.curRptPara.name = $("#resume").prop("files")[0].name;
    }
    deleteReport(user, resume, j) {
      // this.usersList[i].RESUMES.splice(j, 1)
      // for(let i=0; i<this.usersList.length;i++){
      // 	if(this.usersList[i].RESUMES.RESUME_ID==resume.RESUME_ID){
      // 		this.ngZone.run(() => {
      // 			this.usersList[i].RESUMES.splice(j, 1)
      // 		})
      // 	}			
      
      // }
      user.RESUMES.splice(j,1);
      let inputJson = { "PROCEDURE": "deleteuserresume", "USER_ID": parseInt(this.userInfo.USER_ID), "RESUME_ID": resume.RESUME_ID }
      this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
        if(data.RESPONSE_STATUS=='N'){
			this.throwError(data);
		  }	
      });
    }
	clearForms(){
		//this.userData=null;
		this.resetWarn = false;
		this.resetForm.reset();
	}
	clearForms1(){
		//this.userData=null;
		this.resetWarn = false;
		this.resetForm1.reset();
	}
	passwordCheck=false;
  	resetForm
	startReset(){console.log(this.resetForm)
		if(!this.resetForm){
			this.resetForm= this.fb.group({			
				oldpassword:['',[Validators.required]],
				// the regex checks for length >= 8, 1 upper, 1 lower, 1 symbol, 1 number.
				// the symbols are just every symbol i can find on my keyboard
				password:['',[Validators.required, Validators.pattern("(?=(.*[A-Z]){1,})(?=(.*[a-z]){1,})(?=(.*[`~!@#$%^&*()\\-_+=[\\]{}\\\|;:'\",<.>/?]){1,})(?=(.*[0-9]){1,}).{8,}")]],
				confirmpassword:['',[Validators.required]],
			});
		}
		this.resetForm.reset();
		this.toReset=true;
	}
	resetWarn
	reseWarnMessage  
	resetPsw(){
		if(this.resetForm.valid && this.resetForm.value.password == this.resetForm.value.confirmpassword){
			let oldpassword = this.resetForm.value.oldpassword
			let newpassword = this.resetForm.value.password //$('#newpassword').val();;
			let inputJson={"PROCEDURE":"changerwuserpassword","USER_ID":parseInt(this.userInfo.USER_ID),"OLD_PASSWORD":oldpassword,"NEW_PASSWORD":newpassword}
		 	console.log(inputJson)
			this.reportService.univeralService(JSON.stringify(inputJson))
			.subscribe(data => {
			 	if(data.RESPONSE_STATUS == 'N'){
					this.resetWarn = true;
          			this.reseWarnMessage = data.MESSAGE;
					this.throwError(data);
					return
				}
				if(data.RESPONSE_STATUS == 'Y'){
					Swal.fire({
						 html: '<p style="font-size:16px; color:green">'+data.MESSAGE+'</p>',
						 timer: 2000,
						 showConfirmButton:false,						 
					   })
					this.clearForms();	
					$('#resetModal').modal('hide');			  
				}
			})
		  }else {
			//this.noPassWordError = true
		  }		
	}
	resetForm1:any;
	toMbileSet=false;
	startMobilePsw(){
		if(!this.resetForm1){
			this.resetForm1= this.fb.group({			
				//oldpassword:['',[Validators.required]],
				// the regex checks for length >= 8, 1 upper, 1 lower, 1 symbol, 1 number.
				// the symbols are just every symbol i can find on my keyboard
				password:['',[Validators.required, Validators.pattern("(?=(.*[A-Z]){1,})(?=(.*[a-z]){1,})(?=(.*[`~!@#$%^&*()\\-_+=[\\]{}\\\|;:'\",<.>/?]){1,})(?=(.*[0-9]){1,}).{8,}")]],
				confirmpassword:['',[Validators.required]],
			});
		}
		this.resetForm1.reset();
		this.toMbileSet=true;
	}
	setMobilePsw(){
		if(this.resetForm1.valid && this.resetForm1.value.password == this.resetForm1.value.confirmpassword){
			let newpassword = this.resetForm1.value.password;
			let inputJson={"PROCEDURE":"setssomobilelogin","USER_ID":parseInt(this.userInfo.USER_ID),"PASSWORD":newpassword}
			console.log(inputJson)
			this.reportService.univeralService(JSON.stringify(inputJson))
			.subscribe(data => {
			 	if(data.RESPONSE_STATUS == 'N'){
					this.resetWarn = true;
          			this.reseWarnMessage = data.MESSAGE;
					this.throwError(data);
					return
				}
				if(data.RESPONSE_STATUS == 'Y'){
					Swal.fire({
						 html: '<p style="font-size:16px; color:green">'+data.MESSAGE+'</p>',
						 timer: 2000,
						 showConfirmButton:false,						 
					   })
					this.clearForms1();	
					$('#mobileModal').modal('hide');			  
				}
			})
		  }else {
			//this.noPassWordError = true
		  }	
	}
	private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
  
  resumeToDelete: any = null;
  
  showDeleteResumeConfirm(user, resume, j) {
    this.resumeToDelete = { user, resume, j };
    Swal.fire({
      title: 'Are you sure you want to delete the resume?',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Go Back',
      confirmButtonColor: '#007bff',
      cancelButtonColor: '#6c757d',
      reverseButtons: true,
      customClass: {
        popup: 'swal2-company-style',
        title: 'swal2-company-title',
        confirmButton: 'swal2-company-confirm',
        cancelButton: 'swal2-company-cancel',
        actions: 'swal2-company-actions'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.confirmDeleteResume();
      } else {
        this.resumeToDelete = null;
      }
    });
  }

  dismissConfirm(event) {
    this.resumeToDelete = null;
  }

  confirmDeleteResume() {
    if (this.resumeToDelete) {
      this.deleteReport(this.resumeToDelete.user, this.resumeToDelete.resume, this.resumeToDelete.j);
      this.resumeToDelete = null;
    }
  }
}
